import React, { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { stepperIncrease } from 'actions/view'
import {
  Hidden,
  Button as MuiButton,
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core'
import {
  ArrowDropDown,
  Done,
  SettingsInputAntenna,
  Loop,
  Pause,
} from '@material-ui/icons'
import { updateStatus } from 'actions/campaign/addOrEdit'
// import { themeObj } from 'components/withRoot'
// import language from 'utils/vast-languagepack'

const styles = (theme) => ({
  W: {
    color: '#fff',
    backgroundColor: theme.palette.pink,
    '&:hover': { backgroundColor: '#72064f' },
    '&:focus': { backgroundColor: '#72064f' },
  },
  P: {
    color: '#fff',
    backgroundColor: theme.palette.orange,
    '&:hover': { backgroundColor: '#aa7404' },
    '&:focus': { backgroundColor: '#aa7404' },
  },
  L: {
    color: '#fff',
    backgroundColor: theme.palette.green,
    '&:hover': { backgroundColor: '#108a2e' },
    '&:focus': { backgroundColor: '#108a2e' },
  },
  C: {
    color: '#fff',
    backgroundColor: theme.palette.secondary.main,
    '&:hover': { backgroundColor: '#013567' },
    '&:focus': { backgroundColor: '#013567' },
  },
})

export const IconMap = {
  W: (fontSize) => (
    <Loop
      style={fontSize ? { fontSize, marginRight: 5 } : { marginRight: 5 }}
    />
  ),
  P: (fontSize) => (
    <Pause
      style={fontSize ? { fontSize, marginRight: 5 } : { marginRight: 5 }}
    />
  ),
  L: (fontSize) => (
    <SettingsInputAntenna
      style={fontSize ? { fontSize, marginRight: 5 } : { marginRight: 5 }}
    />
  ),
  C: (fontSize) => (
    <Done
      style={fontSize ? { fontSize, marginRight: 5 } : { marginRight: 5 }}
    />
  ),
}

const NextButton = ({
  pastFirstStep,
  stepperIncrease,
  newEntity,
  status,
  classes,
  updateStatus,
  stages,
  calendarLength,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  // const tooltipMap = {
  //   W: language.campaign.campaignStatus.campaignPlay,
  //   P: language.campaign.campaignStatus.campaignPause,
  //   L: language.campaign.campaignStatus.campaignLive,
  //   C: language.campaign.campaignStatus.campaignComplete,
  // }

  const textMap = {
    W: 'Work in progress',
    P: 'Paused',
    L: 'Live',
    C: 'Complete',
  }

  const campaignButtonStyle = {
    borderTopLeftRadius: 35,
    borderBottomLeftRadius: 35,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    color: '#fff',
  }

  const campaignMenuButtonStyle = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 35,
    borderBottomRightRadius: 35,
    padding: 6,
    minWidth: 0,
    color: '#fff',
    height: 36.5,
  }

  const campaignButton = (size, fontSize) => (
    <Fragment>
      <MuiButton
        disabled={!status || status === 'C'}
        className={classes[status]}
        style={
          fontSize ? { ...campaignButtonStyle, fontSize } : campaignButtonStyle
        }
        variant="contained"
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        {IconMap[status] && IconMap[status](fontSize)}
        {textMap[status]}
      </MuiButton>
      <MuiButton
        disabled={!status || status === 'C'}
        className={classes[status]}
        aria-owns={anchorEl ? 'campaign-menu-side-button-menu' : undefined}
        aria-haspopup="true"
        onClick={e => setAnchorEl(e.currentTarget)}
        variant="contained"
        style={
          fontSize
            ? {
                ...campaignMenuButtonStyle,
                height: size === 'medium' ? 36.5 : undefined,
                fontSize,
              }
            : campaignMenuButtonStyle
        }
      >
        <ArrowDropDown style={fontSize ? { fontSize, minHeight: 14 } : null} />
      </MuiButton>
      <Menu
        id="campaign-menu-side-button-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {status === 'W' || status === 'P' ? (
          <MenuItem
            // disabled={
            //   stages.some((stage) => !stage.event_goals.length) ||
            //   (!stages.length && !calendarLength)
            // }
            classes={{ root: classes.L }}
            onClick={() => {
              setAnchorEl(null)
              updateStatus('W')
            }}
          >
            {IconMap.L()}
            Go Live
          </MenuItem>
        ) : null}
        {status === 'L' ? (
          <MenuItem
            classes={{ root: classes.P }}
            onClick={() => {
              setAnchorEl(null)
              updateStatus('L')
            }}
          >
            {IconMap.P()}
            Pause
          </MenuItem>
        ) : null}
      </Menu>
    </Fragment>
  )

  const button = (size, fontSize) => (
    <Button
      disabled={newEntity}
      style={fontSize ? { fontSize } : null}
      variant="contained"
      color="secondary"
      onClick={() => stepperIncrease('campaign')}
    >
      Next
    </Button>
  )

  return pastFirstStep ? (
    <Fragment>
      <Hidden smDown>{campaignButton('medium')}</Hidden>
      <Hidden mdUp>{campaignButton('small', 8)}</Hidden>
    </Fragment>
  ) : (
    <Fragment>
      <Hidden smDown>{button('medium')}</Hidden>
      <Hidden mdUp>{button('small', 8)}</Hidden>
    </Fragment>
  )
}

export default connect(
  (state, { stepsLength }) => ({
    pastFirstStep: state.view.stepper.campaign !== 0,
    status: state.campaign.addOrEdit.campaign.status,
    stagesLength: state.campaign.addOrEdit.campaign.stages,
    calendarLength: state.campaign.addOrEdit.campaign.calendar.length,
  }),
  (dispatch) => bindActionCreators({ stepperIncrease, updateStatus }, dispatch),
)(withStyles(styles)(NextButton))
